import {viewportBreakpointSizes} from '@mamdev/cad.static-next-lib';

export const consoleLog = (...args: unknown[]) => console.log('[video-slideshow]', ...args);
export const consoleWarn = (...args: unknown[]) => console.warn('[video-slideshow]', ...args);
export const consoleError = (...args: unknown[]) => console.error('[video-slideshow]', ...args);

export function isDesktop() {
  return window.innerWidth >= viewportBreakpointSizes.desktop;
}

export function isMobile() {
  return window.innerWidth < viewportBreakpointSizes.tablet;
}

/**
 * Ensures a number is never outside the specified min and max values.
 */
export function clamp(num: number, min: number, max: number): number {
  return Math.min(Math.max(num, min), max);
}

/**
 * Formats video time nicely as "mm:ss" to be displayed in the timestamp UI element.
 * @param seconds The video time.
 */
export function formatTime(seconds: number): string {
  let elapsedMinutes = Math.floor(seconds / 60);
  let elapsedSeconds = Math.round(seconds % 60);

  if (elapsedMinutes < 0) elapsedMinutes = 0;
  if (elapsedSeconds < 0) elapsedSeconds = 0;

  // Format the time as mm:ss (pad minutes and seconds with leading zeros)
  const formattedMinutes = elapsedMinutes.toString().padStart(2, '0');
  const formattedSeconds = elapsedSeconds.toString().padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
}

/**
 * Returns the index of the slide containing the specified ad container element.
 * @param container The ad container element.
 */
export function getSlideIndexFromAdContainer(container: HTMLElement) {
  if (container) {
    const slideElement = container.closest<HTMLElement>('.video-slideshow__slide');
    return parseInt(slideElement?.dataset.index ?? '');
  }
}

/**
 * Determines if the contents of an element are larger than the element itself.
 */
export function elementContentOverflows(e: HTMLElement) {
  if (e) return e.scrollWidth > e.offsetWidth;
}
